import { Injectable } from '@angular/core';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { FormError } from 'src/app/angular-elements/shared/components/interfaces/form-error.interface';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentSubmissionMAService {

    productGroup = PRODUCT_GROUPS.MEDICARE_ADVANTAGE;
    productType = 'MA';

    constructor() { }

    validateMandatoryFields(payload: any, activeProductGroup: PRODUCT_GROUPS): FormError {
        const formErr: FormError = {
            valid: true,
            fieldName: ''
        };
        if (activeProductGroup === PRODUCT_GROUPS.MEDICARE_ADVANTAGE) {
            if (payload.enrollment && payload.enrollment.productData) {
                if (!payload.enrollment.productData.cmsPlanID) {
                    formErr.valid = false;
                    formErr.fieldName = 'CMS Plan ID';
                }
            } else {
                formErr.valid = false;
            }
        }
        return formErr;
    }
}

